import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import { Link } from "react-router-dom";

const PageNotFound = () => {
  return (
    <React.Fragment>
      <SEO title="404 Page Not Found | DMBD 2025" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Page Not Found"
        content="Page Not Found"
        contentTwo="Page Not Found"
        linkage="/"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div classNameName="entry-header">
            <h1>404</h1>
            <h1>Page Not Found!</h1>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classNameOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default PageNotFound;
